import type { CanvasBackgroundKey, FocusSoundscapeKey } from '../types/schema'

/**
 * Returns true if the canvas background is free (unlocked by default: DEFAULT or BLUEPRINT_GRID).
 * Unlockable backgrounds (NEBULA, CIRCUIT) require the Fun Pack module.
 */
export function isFreeCanvasBackground(key: CanvasBackgroundKey): boolean {
  return key === 'DEFAULT' || key === 'BLUEPRINT_GRID'
}

/**
 * Derives the active canvas background, falling back unlockables to DEFAULT when fun pack is OFF.
 */
export function effectiveCanvasBackground(
  key: CanvasBackgroundKey,
  funPackOff: boolean,
): CanvasBackgroundKey {
  if (funPackOff && (key === 'NEBULA' || key === 'CIRCUIT')) {
    return 'DEFAULT'
  }
  return key
}

/**
 * Returns true if the focus soundscape is free (unlocked by default: SILENCE).
 * Unlockable soundscapes (LOFI_RAIN, ALPHA_WAVE) require the Fun Pack module.
 */
export function isFreeFocusSoundscape(key: FocusSoundscapeKey): boolean {
  return key === 'SILENCE'
}

/**
 * Derives the active focus soundscape, falling back unlockables to SILENCE when fun pack is OFF.
 */
export function effectiveFocusSoundscape(
  key: FocusSoundscapeKey,
  funPackOff: boolean,
): FocusSoundscapeKey {
  if (funPackOff && (key === 'LOFI_RAIN' || key === 'ALPHA_WAVE')) {
    return 'SILENCE'
  }
  return key
}
